import { render, staticRenderFns } from "./CardRenderData.vue?vue&type=template&id=778a7981&"
import script from "./CardRenderData.vue?vue&type=script&lang=ts&"
export * from "./CardRenderData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports